import { SortingState } from "@tanstack/react-table"
import { useState } from "react"

import { useCustomReactTable } from "~/components/hooks/useCustomReactTable"
import { CustomTable } from "~/components/table/CustomTable"
import { FindAllActivitiesResponseDto } from "~/gen/api"
import { useColumns } from "~/pages/Admin/Ingestion/Activities/columns"

type Props = {
  activities: FindAllActivitiesResponseDto[]
}

export function Activities({ activities }: Props) {
  const columns = useColumns(activities)
  const [sorting, setSorting] = useState<SortingState>([
    { id: "id", desc: false },
  ])

  const table = useCustomReactTable({
    data: activities,
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
  })

  return <CustomTable table={table} pagination={false} />
}
